export default __webpack_public_path__ + "static/access_reviews-1c83db4790190263f59811b1b1d29a52.svg";